import { aggregateScore, aggregateSubtopicScore, scorePercent } from '../lib/progress.js';

function DualGauge({ first, second, type }) {
  return (
    <div className="dual-gauge-wrap">
      <div className={`dual-gauge dual-gauge-${type}`} aria-label={`${first}% and ${second}% complete`}>
        <span style={{ width: `${first / 2}%` }} />
        <span style={{ width: `${second / 2}%` }} />
      </div>
      <div className="dual-gauge-labels">
        {type === 'vocabulary'
          ? <><span>Guided {first}%</span><span>Building {second}%</span></>
          : <><span>🎧 Spell {first}%</span><span>🔎 Details {second}%</span></>}
      </div>
    </div>
  );
}

export default function SubtopicDirectory({ theme, index, progress, onOpen, onBack }) {
  const isVocabulary = theme.groupId === 'vocabulary-collocation';
  const modes = isVocabulary
    ? ['guided-practice', 'sentence-building']
    : ['listen-spell', 'listen-for-details'];

  return (
    <main className="page subtopic-page">
      <button className="back-button" type="button" onClick={onBack}>← All themes</button>
      <section className="chosen-context">
        <span className="chosen-number">{String(theme.number).padStart(2, '0')}</span>
        <span><small>CHOSEN THEME</small><strong>{theme.title}</strong></span>
      </section>
      <div className="directory-title-row subtopic-title-row">
        <div>
          <p className="eyebrow coral-eyebrow">EXPLORE THE THEME</p>
          <h1>Choose a subtopic</h1>
        </div>
      </div>
      <section className="subtopic-grid">
        {index.subtopics.map((subtopic, indexNumber) => {
          const count = isVocabulary ? subtopic.counts?.headwords : subtopic.targetCount;
          const firstScore = isVocabulary
            ? aggregateSubtopicScore(progress, {
              themeId: theme.id,
              subtopicId: subtopic.id,
              mode: modes[0],
              totalUnits: count,
              maximumPerUnit: 10,
            })
            : aggregateScore(progress, theme.id, modes[0], subtopic.id);
          const secondScore = isVocabulary
            ? aggregateSubtopicScore(progress, {
              themeId: theme.id,
              subtopicId: subtopic.id,
              mode: modes[1],
              totalUnits: count,
              maximumPerUnit: 15,
            })
            : aggregateScore(progress, theme.id, modes[1], subtopic.id);
          return (
            <button className="subtopic-card" type="button" key={subtopic.id} onClick={() => onOpen(subtopic.id)}>
              <span className="subtopic-heading">
                <span className="subtopic-index">{String(indexNumber + 1).padStart(2, '0')}</span>
                <span>
                  <strong>{subtopic.title}</strong>
                  {subtopic.titleZh && <small lang="zh-Hant">{subtopic.titleZh}</small>}
                </span>
                <span className="subtopic-arrow" aria-hidden="true">→</span>
              </span>
              <span className="subtopic-count">{count} {isVocabulary ? 'headwords' : 'listening targets'}</span>
              <DualGauge
                first={scorePercent(firstScore)}
                second={scorePercent(secondScore)}
                type={isVocabulary ? 'vocabulary' : 'listening'}
              />
            </button>
          );
        })}
      </section>
    </main>
  );
}
